import React, { useEffect, useRef } from "react";
import { endpoints } from "Core/defaultValues";

const EVIRIBView = () => {
  const iframeRef = useRef(null);

  // Get the token
  const idToken = localStorage.getItem("IdToken");
  const refreshToken = localStorage.getItem("RefreshToken");
  const username = localStorage.getItem("username");

  useEffect(() => {
    const sendToken = () => {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.postMessage(
          { idToken, refreshToken, username },
          endpoints.EVIR_IB_WEB_URL
        );
      }
    };

    // Send the token once the iframe loads
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.onload = sendToken;
    }
  }, [idToken]); // Re-run if the token changes

  return (
    <div style={{ height: "95vh" }}>
      <iframe
        ref={iframeRef}
        id="inspection-builder-portal"
        title="Inspection Builder Portal"
        width="100%"
        height="100%"
        src={endpoints.EVIR_IB_WEB_URL}
      ></iframe>
    </div>
  );
};

export default EVIRIBView;
